<template>
  <label id="uploader">
    <slot>
      <span>修改头像</span>
    </slot>
    <input class="weui-uploader__input" type="file" accept="image/*" multiple="" @click="clickUpload">
  </label>
</template>

<script>
/* eslint-disable */
import weui from 'weui.js';
import weui2 from '@/wechat/weui';

import config from '@/config';
import auth from '@/auth';

export default {
    data() {
        return {
            confirmed: false,
        };
    },
    mounted() {
        const vm = this;
        let loading;
        weui.uploader('#uploader', {
            url: `${config.api}/coach/image/avatar`,
            auto: true,
            type: 'file',
            fileVal: 'file',
            compress: false,
            onBeforeQueued(files) {
                console.log('Before: ', this);
                // `this` 是轮询到的文件, `files` 是所有文件

                if (['image/jpg', 'image/jpeg', 'image/png', 'image/gif'].indexOf(this.type) < 0) {
                    weui.alert('请上传图片');
                    return false; // 阻止文件添加
                }
                if (this.size > 10 * 1024 * 1024) {
                    weui.alert('请上传不超过10M的图片');
                    return false;
                }
                if (files.length > 1) { // 防止一下子选择过多文件
                    weui.alert('最多只能上传1张图片，请重新选择');
                    return false;
                }

                return true; // 阻止默认行为，不插入预览图的框架
            },
            onQueued() {
                console.log('Queued: ', this);

                // console.log(this.status); // 文件的状态：'ready', 'progress', 'success', 'fail'
                // console.log(this.base64); // 如果是base64上传，file.base64可以获得文件的base64

                // this.upload(); // 如果是手动上传，这里可以通过调用upload来实现；也可以用它来实现重传。
                // this.stop(); // 中断上传

                // return true; // 阻止默认行为，不显示预览图的图像
            },
            onBeforeSend(data, headers) {
                // eslint-disable-next-line no-param-reassign
                headers.Authorization = `Bearer ${auth.token()}`;
                // eslint-disable-next-line no-param-reassign
                headers.Accept = 'application/json';

                loading = weui.loading('上传中...');
                console.log('Sending: ', this, data, headers);
                // $.extend(data, { test: 1 }); // 可以扩展此对象来控制上传参数
                // $.extend(headers, { Origin: 'http://127.0.0.1' }); // 可以扩展此对象来控制上传头部

                // return false; // 阻止文件上传
            },
            onProgress(percent) {
                console.log('Progress: ', this, percent);
                // return true; // 阻止默认行为，不使用默认的进度显示
            },
            onSuccess(ret) {
                console.log('Success: ', this, ret);
                vm.$emit('input', ret.url);
                if (loading) {
                    loading.hide();
                }
            },
            onError(err) {
                console.log('Error: ', this, err);
                // return true; // 阻止默认行为，不使用默认的失败态
                if (loading) {
                    loading.hide();
                }
                weui.topTips('上传失败！');
            },
        });
    },
    methods: {
        async clickUpload(evt) {
            if (this.confirmed) {
                this.confirmed = false;
                return true;
            }

            evt.preventDefault();
            const confirmed = await weui2.dialog({
                content: '系统将自动截取图片中心正方形区域，你可以先自行编辑为正方形，或者通过身材觉醒APP上传头像。',
                buttons: [
                    {
                        label: '继续上传',
                        type: 'primary',
                        value: true,
                    },
                    {
                        label: '继续编辑',
                    },
                ],
            });

            if (confirmed) {
                this.confirmed = true;
                console.log('Trigger click');
                evt.target.click();
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/coach/Uploader.vue